import { render, staticRenderFns } from "./AssessorReportDocument.vue?vue&type=template&id=a6b0cc8c&"
import script from "./AssessorReportDocument.vue?vue&type=script&lang=js&"
export * from "./AssessorReportDocument.vue?vue&type=script&lang=js&"
import style0 from "./AssessorReportDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports